// src/utils/deepLinking.ts
import { supabase } from '@/integrations/supabase/client'; // Moved import to the top

// Function to store a deep link path in session storage
export const storeDeepLink = (path: string) => {
  try {
    // Store the path
    sessionStorage.setItem('deepLinkPath', path);
    // REMOVED: Storing domain context
    console.log(`Stored deep link: ${path}`); // Updated log message
  } catch (error) {
    console.error('Failed to store deep link:', error);
  }
};

// Function to retrieve and clear a stored deep link path
export const retrieveDeepLink = () => {
  try {
    const path = sessionStorage.getItem('deepLinkPath');
    // REMOVED: Retrieving domain context

    // Clear the stored deep link
    sessionStorage.removeItem('deepLinkPath');
    // REMOVED: Removing domain context item

    console.log(`Retrieved deep link: ${path}`); // Updated log message

    // REMOVED: Domain context check - return path directly
    return path; // Directly return the path
  } catch (error) {
    console.error('Failed to retrieve deep link:', error);
    return null;
  }
};

// Function to get and clear the deep link in one operation
export const getAndClearDeepLink = () => {
  return retrieveDeepLink();
};

// Function to check if a path requires authentication
export const requiresAuth = (path: string) => {
  // Updated list of paths requiring authentication for the main trading app
  const authRequiredPaths = [
    '/dashboard',
    // REMOVED: '/bracket-builder',
    '/chat-history',
    '/trading-history',
    '/compliance',
    '/market-analysis',
    // REMOVED: '/admin-dashboard' (as per user confirmation)
    // REMOVED: '/admin' (as per user confirmation)
    '/settings' // Added settings as it's usually protected
  ];

  return authRequiredPaths.some(prefix =>
    path === prefix || path.startsWith(`${prefix}/`)
  );
};

// Function to check authentication status
export const checkAuthStatus = async () => {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    return !!session;
  } catch (error) {
    console.error('Error checking auth status:', error);
    return false;
  }
};

// REMOVED: Import statement from the bottom as it's now at the top
